<template>
	<aside class="alerts-container">

		<h2>{{ header }}</h2>

		<alerts-nav @change="paneChange" :activeLeft="activeLeft" :data-active-left="activeLeft"/>

		<slot v-if="activeLeft" 	name="left" data-alertsection/>
		<slot v-if="!activeLeft"  	name="right" data-alertsection/>

	</aside>
</template>

<script>
import AlertsNav from "@/components/ui/nav/AlertsNav"
export default {
	name: "AlertsContainer",
	props: ['header'],
	components: {
		AlertsNav
	},
	data () {
		return {
			activeLeft: true
		}
	},
	methods: {
		paneChange (activePane) {
			this.activeLeft = activePane === 'left'
		}
	}
}

</script>

<style lang="scss" scoped>
	@import '@/scss/imports.scss';
	.alerts-container {

		display: inline-block;
		width: 49.5%; height: 50vh;	
		border: solid 1px #dddddd;
		overflow: hidden;	
		@media only screen and (max-width: 600px) {
			width: 100%;
		}
		h2 {
			text-align: center;
			font-size: 16px;
			font-weight: 900px;
			height: 45px;
			margin-top: 30px;
			padding: 10px;

		}
		&[data-bottom] {
			h2 { margin-top: 10px; }
		}
		&[data-right] {
			border-left: solid 1px #d8d8d8; 
		}
		&[data-active-left="true"] {
			background-color: #d8d8d8;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/ui/AlertsContainer.vue